import React from 'react'
import { Button, Typography } from '@mui/material'

//types
import { MaybeLaterButtonProps } from 'types'

export const MaybeLaterButton = ({ hideModal }: MaybeLaterButtonProps) => {
  return (
    <Button sx={styles.button} onClick={hideModal}>
      <Typography variant="h3" sx={styles.buttonText}>
        Maybe later
      </Typography>
    </Button>
  )
}

const styles = {
  button: {
    textAlign: 'center',
    textDecoration: 'underline',
    textDecorationColor: '#1E40AF',
    textDecorationStyle: 'solid',
    textDecorationSkipInk: 'none',
    textUnderlinePosition: 'under',
    textTransform: 'none',
    '&:hover': {
      textDecoration: 'underline',
      textDecorationColor: '#1E40AF',
    },
  },
  buttonText: {
    fontWeight: 400,
    color: '#1E40AF',
    fontFamily: 'var(--inter-font)',
  },
}
